import React from 'react';
import { MonitorIcon, SmartphoneIcon } from 'lucide-react';
import type { Format } from '../../types/presentation';
interface FormatToggleProps {
  value: Format;
  onChange: (format: Format) => void;
}
export function FormatToggle({
  value,
  onChange
}: FormatToggleProps) {
  return <div role="group" aria-label="Presentation format" className="inline-flex items-center gap-1 rounded-full border border-navy/[0.14] bg-paper/70 p-1" data-id="element-443" data-mp="309l6u569jytk">
      <Option active={value === 'mobile'} onClick={() => onChange('mobile')} label="Phone" data-id="element-444" data-mp="rvdss6h9u6y">
        <SmartphoneIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-445" data-mp="3svw4p82hjlmo" />
      </Option>
      <Option active={value === 'desktop'} onClick={() => onChange('desktop')} label="Desktop" data-id="element-446" data-mp="3nx2rzhv0vynk">
        <MonitorIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-447" data-mp="3izb4d01euyp6" />
      </Option>
    </div>;
}
function Option({
  children,
  label,
  active,
  onClick
}: {
  children: React.ReactNode;
  label: string;
  active: boolean;
  onClick: () => void;
}) {
  return <button type="button" onClick={onClick} aria-pressed={active} className={['inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-[10px] uppercase tracking-[0.16em] transition-colors duration-150', 'focus:outline-none focus-visible:ring-2 focus-visible:ring-blue', active ? 'bg-navy text-paper' : 'text-navy/50 hover:text-navy'].join(' ')} data-id="element-448" data-mp="1wp6ea8e74kr5">
      {children}
      <span className="hidden sm:inline" data-id="element-449" data-mp="1czw0izy0g9vo">{label}</span>
    </button>;
}